import config from '@/config';
import { LogicContext } from '@/logic/main/types';
import { isSingleJackpot } from '@/logic/main/utils';
import { fetchJackpotsV2 } from '@/model/jackpotsV2';
import { JackpotsV2ResponseType } from '@/types/jackpotTypes';
import { fromEntries } from '@/utils/lodash-alternatives';

export const refetchStaleJackpots = async (context: LogicContext) => {
  const {
    features: { jackpotsV2 },
    intervals,
  } = config;
  if (jackpotsV2?.mode !== 'enabled' || !intervals?.jackpots?.games) {
    return {};
  }

  const currency = context.user?.currency || config.default_currency;
  const currentTimestamp = Date.now();
  const jackpotResponses = Object.entries(context.currentJackpotsV2).reduce(
    (acc, [provider, jackpotResponse]) => {
      const gamesJackpotCodes = Object.entries(jackpotResponse)
        .filter(([jpCode, jackpot]) => {
          const jpUpdateInterval =
            isSingleJackpot(jackpot) && jackpot.value.updateInterval;
          const updateInterval = jpUpdateInterval || intervals.jackpots.games;
          const jpTimestamp = Date.parse(jackpot.timestamp);
          return jpTimestamp + updateInterval < currentTimestamp;
        })
        .map(([jpCode]) => jpCode);
      if (gamesJackpotCodes.length) {
        const jackpot = fetchJackpotsV2({
          currency,
          gamesJackpotCodes,
          provider,
        }).then(response => [provider, response] as const);
        acc.push(jackpot);
      }
      return acc;
    },
    [] as Promise<readonly [string, JackpotsV2ResponseType]>[]
  );
  if (!Object.fromEntries) Object.fromEntries = fromEntries;
  const jackpots = Object.fromEntries(await Promise.all(jackpotResponses));
  return { jackpots };
};
